
  import { Vue, Component, Prop } from "vue-property-decorator";

  import PaymentCard from "@/components/payment/PaymentCard.vue";
  import UIButton from "@/components/button/ui-button.vue";

  import { Payment_Card } from "@/generated/graphql";

  @Component({
    components: {
      PaymentCard,
      UIButton,
    },
  })
  export default class PaymentCardsList extends Vue {
    @Prop({ type: Array, required: true }) readonly paymentCards!: Payment_Card[];
    @Prop({ type: Boolean, required: true }) readonly processing!: boolean;
  }
